import {request} from './request'


export function Province(province__city = '全国') {
    return request({
        url: '/hp/citys/',
        params: {
            province__city,
        }
    });
}

export function Type(main_type_name__type_name = '主分类') {
    return request({
        url: '/hp/project-types/',
        params: {
            main_type_name__type_name,
        }
    });
}

export function getProvincials(recently='最近一月', compile_unit_scid) {
    return request({
        url: '/hp/public-supervision/provincials/',
        params: {
            recently,
            compile_unit_scid
        }
    });
}


